import React, { Suspense, lazy, Fragment } from "react";
import Loading from "../components/loading/Loading";
import PublicRoute from "./publicRoute/PublicRoute";
import "../features/auth/authPrimaryBtn.scss";

const Login = lazy(() => import("../features/auth/login/Login"));
const ForgotPassword = lazy(() => import("../features/auth/forgotPassword/ForgotPassword"));
const VerifyEmail = lazy(() => import("../features/auth/verifyEmail/VerifyEmail"));
const ResetPassword = lazy(() => import("../features/auth/resetPassword/ResetPassword"));
const LetsGetStart = lazy(() => import("../features/auth/letsGetStart/LetsGetStart"));
const SelectAccount = lazy(() => import("../features/auth/selectAccount/SelectAccount"));
const CreateStudentPersonal = lazy(() => import("../features/auth/createStudentPersonal/CreateStudentPersonal"));
const CreateStudentPersonalAccount = lazy(() => import("../features/auth/createStudentPersonalAccount/CreateStudentPersonalAccount"));
const CounSelorRegister = lazy(() => import("../features/auth/counSelorRegister/CounSelorRegister"));
const CreateStudentAccount = lazy(() => import("../features/auth/createStudentAccount/CreateStudentAccount"));
const CreateStudentOTP = lazy(() => import("../features/auth/createStudentOTP/CreateStudentOTP"));
const CreateParentAccount = lazy(() => import("../features/auth/createParentAccount/CreateParentAccount"));

const suspenseRoutesArr = [
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/forgot-password",
    component: ForgotPassword
  },
  {
    path: "/verify-email",
    component: VerifyEmail
  },
  {
    path: "/verify-password/:id?",
    component: ResetPassword
  },
  {
    path: "/lets-get-start",
    component: LetsGetStart
  },
  {
    path: "/select-account",
    component: SelectAccount
  },
  {
    path: "/create-student-personal",
    component: CreateStudentPersonal
  },
  {
    path: "/create-student-personal-account",
    component: CreateStudentPersonalAccount
  },
  {
    path: "/counselor-register",
    component: CounSelorRegister
  },
  {
    path: "/create-student-account",
    component: CreateStudentAccount
  },
  {
    path: "/create-student-otp",
    component: CreateStudentOTP
  },
  {
    path: "/create-parent-account",
    component: CreateParentAccount
  },

];

const PublicRoutes = () => {
  return (
    <Fragment>
      {suspenseRoutesArr.map((route, i) => (
        <Suspense fallback={<Loading />} key={i}>
          <PublicRoute path={route.path} component={route.component} />
        </Suspense>
      ))}
    </Fragment>
  );
};

export default PublicRoutes;
